import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ModalDialogHelper extends Vue
{
	bringToFront(modalDialog: { $el: Element })
	{
		this.$nextTick(() => {
			const elem: Element = modalDialog.$el
			const zIndex = getComputedStyle(elem).getPropertyValue('z-index')

			// @ts-ignore
			elem.style.zIndex = zIndex + 100
		})
	}
}
